import React from "react";
import styles from "./FilesModule.module.scss";
import { Files } from "./Files/Files";
import { FAQ } from "./FAQ/FAQ";
import { ModalAddGoogleDrive } from "../../../ModalAddGoogleDrive/ModalAddGoogleDrive";
import { useDispatch, useSelector } from "react-redux";
import { setNewAssistant } from "../../../../store/slices/assistantSlice";

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Файлы", "Вопрос-ответ"];

  const handleClick = (index) => {
    setActiveTab(index);
  };
  return (
    <div className={styles.tabsContainer} style={{ display: "flex" }}>
      {tabs.map((tab, index) => {
        const isActive = index === activeTab;
        return (
          <div
            key={index}
            className={`${styles.tab} ${isActive ? styles.active : ""}`}
            onClick={() => handleClick(index)}
          >
            {tab}
          </div>
        );
      })}
    </div>
  );
};

export const FilesModule = ({ newAssistant }) => {
  const dispatch = useDispatch();

  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const [activeTab, setActiveTab] = React.useState(0);
  const [visibleGoogleDriveModal, setVisibleGoogleDriveModal] =
    React.useState(false);

  const driveFile = updateAssistant
    ? updateAssistant?.driveFile
    : newAssistant?.driveFile;

  const handleCloseModalGoogleDrive = () => {
    setVisibleGoogleDriveModal(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <Files
            driveFile={driveFile}
            newAssistant={!updateAssistant && newAssistant}
            updateAssistant={updateAssistant && updateAssistant}
            onGoogleDriveClick={() => setVisibleGoogleDriveModal(true)}
          />
        );
      case 1:
        return <FAQ />;
      default:
        return "default";
    }
  };

  const handleSetDriveFile = (file) => {
    const updateAssistant = {
      ...newAssistant,
      driveFile: file,
    };

    // console.log("driveFile (files module)", file);
    dispatch(setNewAssistant(updateAssistant));
  };

  return (
    <div className={styles.container}>
      {!updateAssistant && (
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
      <div className={styles.content}>{renderContent()}</div>
      <ModalAddGoogleDrive
        visible={visibleGoogleDriveModal}
        handleClose={handleCloseModalGoogleDrive}
        driveFile={driveFile}
        setDriveFile={handleSetDriveFile}
      />
    </div>
  );
};
